import { render, staticRenderFns } from "./SingleApplication.vue?vue&type=template&id=2d394950&scoped=true&"
import script from "./SingleApplication.vue?vue&type=script&lang=js&"
export * from "./SingleApplication.vue?vue&type=script&lang=js&"
import style0 from "./SingleApplication.vue?vue&type=style&index=0&id=2d394950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d394950",
  null
  
)

export default component.exports